export default [
    {
        path: 'general-log/:activeDialog?/:activeId?/:activeGroupId?',
        name: 'general-log',
        component: () => import('../views/GeneralLogPage.vue'),
        props: true,
    },
];
